export const convertingYearsAndMonthsToDays = (obj) => {
    let y = 0, m = 0, d = 0;

    if (+obj.yearAndMonth.year) {
        y = +obj.yearAndMonth.year * 12 * 30;
    }
    
    if (+obj.yearAndMonth.month || +obj.monthAndDay.month) {
        m = (+obj.yearAndMonth.month || +obj.monthAndDay.month) * 30;
    }
    
    if (+obj.day || +obj.monthAndDay.day) {
        d = (+obj.day || +obj.monthAndDay.day);
    }
    
    // console.log('y + m + d;', y, m, d);

    return y + m + d;
};

export const convertingDaysToYearsAndMonths = (obj) => {

    function calculateAge(x) {
        let y = 360,
            y2 = 30,
            remainder = x % y,
            day = remainder % y2,
            year = (x - remainder) / y,
            month = (remainder - day) / y2;
            
        return {
            day: day ? day : null,
            monthAndDay: { month: month ? month : 0, day: day ? day : 0 },
            yearAndMonth: { year: year ? year : null, month: +year > 4 ? null : (month ? month : 0) }
        }
    }

    if(obj.ageValues && obj.ageValues.length > 0) {
        for (let i = 0; i < obj.ageValues.length; i++) {
            let age = obj.ageValues[i].ageOnDay;
    
            if(age <= 29) {
                obj.ageValues[i].typeAgeOnDay = 1;
                obj.ageValues[i].age = { day: age, monthAndDay: { day: null, month: null }, yearAndMonth: { year: null, month: null } }
            } else if(age > 29 && age <= 359) {
                obj.ageValues[i].typeAgeOnDay = 2;
                obj.ageValues[i].age = calculateAge(age)
            } if(age > 359) {
                obj.ageValues[i].typeAgeOnDay = 3;
                obj.ageValues[i].age = calculateAge(age)
            }
        }
    }

    if(obj.ageValue) {
        let age = obj.ageValue;

        if(age <= 29) {
            obj.typeAgeOnDay = 1;
            obj.age = { day: age, monthAndDay: { day: null, month: null }, yearAndMonth: { year: null, month: null } }
        } else if(age > 29 && age <= 359) {
            obj.typeAgeOnDay = 2;
            obj.age = calculateAge(age)
        } if(age > 359) {
            obj.typeAgeOnDay = 3;
            obj.age = calculateAge(age)
        }
    }
    
    return obj;
};